import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import { Image } from '@jsmdg/yoshi';
import { type IsoCountryCode2Alpha } from '../../helper/iso3166Utils';

const getFlagUrl = (countryCode: string): string | undefined => {
    try {
        // dynamically require flag, only then the fragment url (__webpack_public_path__) will be set correctly
        // eslint-disable-next-line unicorn/prefer-module
        return require(`../../assets/images/flags/${countryCode.toLowerCase()}.png`);
    } catch (error) {
        logToSentry(error as Error);
        return undefined;
    }
};

type FlagProps = {
    readonly countryCode: keyof typeof IsoCountryCode2Alpha;
    readonly className?: string;
};

const Flag = ({ className, countryCode }: FlagProps): JSX.Element | null => {
    const flagUrl = getFlagUrl(countryCode) as string;

    return <Image className={className} src={flagUrl} alt="" lazyLoad />;
};

export { Flag };
